// extracted by mini-css-extract-plugin
module.exports = {"tags":"ProjectInfoTags_tags__enfF0","tag":"ProjectInfoTags_tag__RsjU8"};